export const useGetSortedProjects = (projects: Project[]): Project[] => {
  return [...projects]?.sort((a, b) => {
    // @ts-ignore -- Date() comparison
    return new Date(b?.created) - new Date(a?.created);
  });
};
